import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";
import { PagedData } from "../models/paging/paged-data";
import { Page } from "../models/paging/page";
import { ServerData } from "../models/paging/server-data";
import { environment } from "../../environments/environment";
import { ManagedCylinderInformation } from "../models/managed-cyllinder-information";

@Injectable()
export class ManagedCylinderInformationService {
  constructor(private http: HttpClient) {}

  public getResults(
    page: Page,
    location_Id: number,
    quick_Search: string
  ): Promise<PagedData<ManagedCylinderInformation>> {
    const pagedData = new PagedData<ManagedCylinderInformation>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == "") {
        page.sortBy = "Cyl_Size";
      }
      if (page.sortOrder == undefined || page.sortOrder == "") {
        page.sortOrder = "asc";
      }

      let params = "&location_id=" + location_Id;
      params += "&quick_Search=" + quick_Search;

      this.http
        .get<ServerData>(
          environment.apiUrl +
            "ManagedCylinderInformation/GetTable?size=" +
            page.size +
            "&pageNumber=" +
            page.pageNumber +
            "&sortBy=" +
            page.sortBy +
            "&sortOrder=" +
            page.sortOrder +
            params
        )
        .subscribe(
          (data) => {
            page.totalElements = data.total;
            page.totalPages = page.totalElements / page.size;
            for (let i = 0; i < data.data.length; i++) {
              const jsonObj = data.data[i];
              pagedData.data.push(jsonObj);
            }

            pagedData.page = page;
            resolve(pagedData);
          },
          (error) => {
            reject();
          }
        );
    });
  }

  public save(data: ManagedCylinderInformation): Promise<any> {
    return this.http
      .post(`${environment.apiUrl}ManagedCylinderInformation/Save`, data)
      .toPromise();
  }

  public get(id: number): Promise<ManagedCylinderInformation> {
    return this.http
      .get<ManagedCylinderInformation>(`${environment.apiUrl}ManagedCylinderInformation/Get?id=${id}`)
      .toPromise();
  }
}
